<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">{{targetTableTitle}}</div>
        <div class="setting-addel mr-l15">
          <el-button @click="onAddSecurityRule"><i class="fas fa-plus"></i></el-button>
          <el-button @click="onDeleteSecurityRule" :disabled="selectedRowArray.length === 0"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div>
        <w-header-search-button @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper
      :column-default="columnDefault" @condition-change="onChangeTable" :total="total" remote row-class-name="c-dblclick"
      @row-dblclick="onDblClickRow" @selection-change="changeHandleSelection" style="width:100%;" ref="settingList" slot="body" :data="tableData"
      :columns="tableColumn" :pagination="true" :show-custom-header="true" :show-search-tool="showSearchTool">
    </el-table-wrapper>
    <w-add-rule-setting-sliding-popup slot="body" ref="addRuleSettingSlidingPopup" :vendor-list="vendorList" @load-data="loadData" :target-data="targetData"></w-add-rule-setting-sliding-popup>
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT } from '@/utils/string';
import { isNil } from 'lodash';
import NetdeviceSecurityPolicySettingsAPI from '@/api/settings/netdevice/netdevice-security-policy-settings';
import WAddRuleSettingSlidingPopup from '../popup/AddRuleSettingSlidingPopup';

export default {
  name: 'WRuleSettingList',
  components: {
    WAddRuleSettingSlidingPopup,
  },
  props: {
    targetData: {
      type: Object,
      default: () => {},
    },
    vendorList: {
      type: Array,
    },
  },
  watch: {
    targetData: {
      immedate: true,
      handler() {
        this.$nextTick(() => {
          if (!isNil(this.$refs.settingList)) {
            this.$refs.settingList.clearFilter();
          }
          this.loadData();
          this.targetTableTitle = `${this.targetData.objCompanyName} 룰 목록`;
        });
      },
    },
  },
  data() {
    return {
      total: null,
      columnDefault,
      targetTableTitle: '',
      showSearchTool: false,
      selectedRowArray: [],
      tableData: [],
      tableColumn: [
        {
          type: 'selection',
        },
        {
          prop: 'ruleId',
          label: '룰 아이디',
          searchable: true,
          sortable: true,
          remoteProp: 'ncr.rule_id',
          width: 80,
        },
        {
          prop: 'ruleName',
          label: '룰 이름',
          sortable: true,
          searchable: true,
          remoteProp: 'ncr.rule_name',
          width: 200,
        },
        {
          prop: 'severityName',
          label: '등급',
          sortable: true,
          searchable: true,
          remoteProp: 'ncrs.severity_name',
          width: 80,
        },
        {
          prop: 'ruleStandard',
          label: '판단 기준',
          searchable: true,
          sortable: true,
          remoteProp: 'ncr.rule_standard',
        },
        {
          prop: 'standardAction',
          label: '조치방법',
          searchable: true,
          sortable: true,
          formatter: this.getEmptyText,
          remoteProp: 'ncr.standard_action',
        },
      ],
    };
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.settingList.getParameter();
      const params = {
        objCompanyId: this.targetData.objCompanyId,
        ...tableParams,
      };
      // 선택한 벤더의 룰목록 정보를 조회한다.
      NetdeviceSecurityPolicySettingsAPI.getNetdeviceRuleList(params).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        }
      });
    },
    onChangeTable() {
      this.loadData();
    },
    // 테이블 체크박스 셀렉션 change함수
    changeHandleSelection(selectVal) {
      this.selectedRowArray = selectVal;
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    getEmptyText(row, column, value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    onDeleteSecurityRule() {
      this.$confirm('선택한 대상을 삭제하시겠습니까?', 'Warning', {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        type: 'warning',
      })
        .then(() => {
          NetdeviceSecurityPolicySettingsAPI.deleteNetdeviceRuleList(this.selectedRowArray).then((res) => {
            if (res.data.success) {
              this.loadData();
              this.$message(msgUtil.getCustomResultMsgData('삭제하였습니다.', true));
            } else {
              this.$message(msgUtil.getCustomResultMsgData('삭제하지 못하였습니다.', false));
            }
          });
        })
        .catch(() => {});
    },
    onAddSecurityRule() {
      this.$refs.addRuleSettingSlidingPopup.open();
    },
    onDblClickRow(row) {
      this.$refs.addRuleSettingSlidingPopup.open(row);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/RuleViolationSettings/RuleSettings/component/RuleSettingList.vue